import { SetupFreespinsCommand } from 'commands/setup-freespins-command';
import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import PosterTransitionComponent from 'components/poster-transition/poster-transition';
import { DOPrompts, DOStages, GFCustomLayers } from 'names/do-names';
import HidePromoFSonFreespins from 'slotworks/commands/promo-free-spins/hide-pfs-on-freespins';
import Components from 'slotworks/components/components';
import PromptContent, { LoadType } from 'slotworks/components/prompt/prompt-content';
import Layers from 'slotworks/graphics/layers/layers';
import SmartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import State from 'slotworks/state-machine/states/state';
import WildSticky from './wild-sitcky';
import { GlowFilter } from 'pixi-filters';

export default class EnterFreeSpin extends State {
    public onEnter() {
        super.onEnter();
        HidePromoFSonFreespins();
        bonusBuyComponent.hide();
        const prompt = new PromptContent([DOPrompts.ENTER_FREESPIN]);
        SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
        prompt.addContinueButton("continue");
        Components.matrix.reset();
        Components.matrix.resetSymbols();
        Components.matrix.idleSymbols();
        Components.matrix.resetSymbolPositions();
        Layers.Custom.get(GFCustomLayers.WILD_STICKY).show();
        prompt.setLoadType(LoadType.HIDE_BUTTON);        
        WildSticky.onEnterFreespins();
        PosterTransitionComponent.onStarted.addOnce(() => {
            SetupFreespinsCommand().then(() => {
                const value = Layers.BetBar.getText("freespins_x_of_y_value");
                if(value) {
                    value.filters = [ new GlowFilter(3, 3, 0, 0x1c4aba)];
                }
            });
        });
        Layers.CelebrationBackground.setScene('freespins').execute();
        Components.prompt.showPrompt(prompt, DOStages.FREE_SPIN).then(() => {
            Layers.CelebrationBackground.defaultScene().execute();
            this.complete();
        });
    }

    public complete() {
        PosterTransitionComponent.onStarted.removeAll();
        super.complete();
    }
}



// WEBPACK FOOTER //
// ./src/states/enter-freespin.ts